module.exports = __webpack_public_path__ + "static/media/invite.3feb363c.mp3";